import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { FaBars, FaTimes } from 'react-icons/fa';
import './Navbar.css';
import logo from '../assets/logo.png';

const Navbar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isScrolled, setIsScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleMenu = () => setMenuOpen(!menuOpen);

    const isHomePage = location.pathname === '/';

    const handleNavClick = (path) => {
        setMenuOpen(false);
        if (path.startsWith('#')) {
            if (isHomePage) {
                const element = document.querySelector(path);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            } else {
                navigate('/' + path);
            }
        } else {
            navigate(path);
            window.scrollTo(0, 0);
        }
    };

    return (
        <>
            {/* Mobile Menu Overlay */}
            <AnimatePresence>
                {menuOpen && (
                    <motion.div
                        className="mobile-menu-overlay"
                        initial={{ opacity: 0, x: "100%" }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: "100%" }}
                        transition={{ type: "tween", duration: 0.3 }}
                    >
                        <div className="mobile-menu-header">
                            <img src={logo} alt="Nimai Solutions Logo" className="mobile-logo-img" loading="lazy" />
                            <div className="close-icon" onClick={() => setMenuOpen(false)}>
                                <FaTimes />
                            </div>
                        </div>
                        <div className="mobile-links">
                            <motion.span onClick={() => handleNavClick('#services')} style={{ cursor: 'pointer' }}>Services</motion.span>
                            <motion.span onClick={() => handleNavClick('/portfolio')} style={{ cursor: 'pointer' }}>Portfolio</motion.span>
                            <motion.span onClick={() => handleNavClick('/process')} style={{ cursor: 'pointer' }}>Process</motion.span>
                            <motion.span
                                onClick={() => handleNavClick('/about')}
                                style={{ cursor: 'pointer' }}
                            >
                                About
                            </motion.span>
                            <motion.button
                                className="btn-contact mobile-btn"
                                onClick={() => handleNavClick('/contact')}
                            >
                                Contact Us
                            </motion.button>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>

            <motion.nav
                className={`navbar ${isScrolled ? 'scrolled' : ''}`}
                initial={{ y: -100 }}
                animate={{ y: 0 }}
                transition={{ type: "spring", stiffness: 100 }}
            >
                <div className="logo-area" onClick={() => handleNavClick('/')} style={{ cursor: 'pointer' }}>
                    <img src={logo} alt="Nimai Solutions Logo" className="nav-logo-img" loading="lazy" />
                    Nimai Solutions
                </div>

                {/* Mobile Menu Icon */}
                <div className="menu-icon" onClick={toggleMenu}>
                    <FaBars />
                </div>

                {/* Desktop Links */}
                <div className="nav-links desktop-menu">
                    <span onClick={() => handleNavClick('#services')} style={{ cursor: 'pointer' }}>Services</span>
                    <span onClick={() => handleNavClick('/portfolio')} style={{ cursor: 'pointer', color: location.pathname === '/portfolio' ? '#FF9F1C' : '#ccc' }}>Portfolio</span>
                    <span onClick={() => handleNavClick('/process')} style={{ cursor: 'pointer', color: location.pathname === '/process' ? '#FF9F1C' : '#ccc' }}>Process</span>
                    <span
                        onClick={() => handleNavClick('/about')}
                        style={{ cursor: 'pointer', color: location.pathname === '/about' ? '#FF9F1C' : '#ccc' }}
                    >
                        About
                    </span>
                </div>

                <motion.button
                    className="btn-contact desktop-btn"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => handleNavClick('/contact')}
                >
                    Contact Us
                </motion.button>
            </motion.nav>
        </>
    );
};

export default Navbar;
